import React, { useEffect, useMemo, useState } from 'react';
import { ThemeContext, ThemeContextValue } from './ThemeContext';
import { Theme } from './types';

type Props = React.PropsWithChildren<{
  /**
   * Výchozí téma při inicializaci.
   */
  theme: Theme;
}>;

export const ThemeContextProvider: React.FC<Props> = ({ theme, children }) => {
  const [currTheme, setCurrTheme] = useState<Theme>(theme);

  useEffect(() => {
    setCurrTheme(theme);
  }, [theme]);

  useEffect(() => {
    document.body.className = '';
    if (currTheme.ns) {
      document.body.classList.add(currTheme.ns);
    }
    if (currTheme.className) {
      document.body.classList.add(currTheme.className);
    }
  }, [currTheme, setCurrTheme]);

  const contextValue = useMemo<ThemeContextValue>(
    () => ({
      ns: currTheme.ns,
      className: currTheme.className,
      change: (ns, className) => {
        setCurrTheme({
          ns,
          className,
        });
      },
    }),
    [currTheme, setCurrTheme]
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
